// Youssef Selkani
// 2019

import React, { Component } from 'react'
import {
  Grid,
  Button,
  Form,
  Loader,
  Icon,
  Input,
  Label,
  Image,
  Transition,
  Message,
  Divider
} from 'semantic-ui-react'
import ScrollArea from '@xico2k/react-scroll-area'
import fire, { storage } from '../config/Fire'
import '../App.css'
import ReactPlayer from 'react-player'
import Mailto from 'react-protected-mailto'
import admobHolder from '../assets/admobHolder.png'
import phmap from '../assets/phmap.png'
import MakerComp from '../components/MakerComp'
import MakerNavig from '../components/MakerNavig'
import MakerInputs from '../components/MakerInputs'
import Error from '../components/Error'
import ExperimentalPreview from '../components/ExperimentalPreview'
import StaticSheet from '../components/StaticSheet.js'
import {
  BarChart,
  Bar,
  Area,
  AreaChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  LineChart,
  Line,
  ResponsiveContainer
} from 'recharts'
import renderHTML from 'react-render-html'

const Entities = require('html-entities').XmlEntities
const entities = new Entities()

export default class MakerEdit extends Component {
  constructor (props) {
    super(props)
    this.newComp = this.newComp.bind(this)
    this.previewFunc = this.previewFunc.bind(this)
    this.manageCompFunc = this.manageCompFunc.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.headerType1 = this.headerType1.bind(this)
    this.headerType2 = this.headerType2.bind(this)
    this.headerType3 = this.headerType3.bind(this)
    this.urlBtnFunc = this.urlBtnFunc.bind(this)
    this.navigBtnFunc = this.navigBtnFunc.bind(this)
    this.screenBtnValueFunc = this.screenBtnValueFunc.bind(this)
    this.listValueFunc = this.listValueFunc.bind(this)
    this.submitComp = this.submitComp.bind(this)
    this.cancel = this.cancel.bind(this)
    this.enableWpFunc = this.enableWpFunc.bind(this)
    this.enableWooFunc = this.enableWooFunc.bind(this)
    this.textAlign = this.textAlign.bind(this)
    this.btnTypeFunction = this.btnTypeFunction.bind(this)
    this.handleUpload = this.handleUpload.bind(this)
    this.responsiveImg = this.responsiveImg.bind(this)
    this.cancelResponsive = this.cancelResponsive.bind(this)
    this.chartTypeFunction = this.chartTypeFunction.bind(this)
    this.state = {
      loading: true,
      preview: false,
      screens: [],
      sheets: [],
      comps: [],
      rssFeed: [],
      dragComps: [],
      manageComp: false,
      editor: false,
      out: false,
      responsive: true
    }
  }

  componentDidMount = () => {
    fire.auth().onAuthStateChanged((user) => {
      if (user) {
        const {
          match: { params }
        } = this.props
        let raw = user.email
        let userUnderscore = raw.replace(/\./g, '_')
        this.setState({
          userUnderscore: userUnderscore,
          screenID: params.screenid,
          loading: false
        })
        this.viewScreenComp()
        this.userData()
        this.navigationInfo()
      } else {
        this.props.history.push('/')
      }
    })
  }

  confirm = () => {
    this.setState({ confirm: true })
  }

  deleteScreen = () => {
    this.setState({ loading: true })
    fetch('https://murkstomstag.herokuapp.com/api/v1/delete/screen', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: this.state.userUnderscore,
        screenID: this.state.screenID
      })
    }).then((response) => {
      if (response.status === 200) {
        this.setState({ confirm: null })
        this.props.history.push('/maker')
      } else {
        this.setState({ error: response.status, loading: false })
      }
    })
  }

  responsiveImg = () => {
    this.setState({ responsive: false, align: null, width: null, height: null })
  }

  cancelResponsive = () => {
    this.setState({ responsive: true })
  }

  handleUpload = (e) => {
    if (e.target.files[0]) {
      const img = e.target.files[0]
      this.setState(() => ({ img, uploading: true }))
      const { currentUser } = fire.auth()
      let userUnderscore = currentUser.email.replace(/\./g, '_')
      const uploadTask = storage.ref(`/media/${userUnderscore}/images/${img.name}/`).put(img)
      uploadTask.on(
        'state_changed',
        (snapshot) => {
          const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100)
          this.setState({ progress })
        },
        (error) => {
          console.log(error)
        },
        () => {
          storage
            .ref(`/media/${userUnderscore}/images/`)
            .child(img.name)
            .getDownloadURL()
            .then((imgURL) => {
              this.setState({
                imgURL,
                imgName: img.name,
                uploading: false,
                success: true,
                edit: true
              })
            })
        }
      )
    }
  }

  navigationInfo = (e) => {
    let { userUnderscore } = this.state
    this.setState({ loading: true })
    fetch('https://murkstomstag.herokuapp.com/api/v1/view/navigation', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: userUnderscore
      })
    })
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        if (json.code === 200) {
          if (json.menuOrder === null) {
            this.setState({
              drawer: json.drawer,
              navbar: json.navbar,
              position: json.position,
              startingScreen: json.startingScreen
            })
          } else {
            this.setState({
              drawer: json.drawer,
              navbar: json.navbar,
              position: json.position,
              startingScreen: json.startingScreen
            })
          }
        } else if (json.code === 404) {
          console.log('code 404')
        }
      })
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value, edit: true })
  }
  cancel = (e) => {
    this.clearAll()
    this.setState({
      editComp: false,
      preview: false
    })
  }
  launchEditor = (item) => {
    setTimeout(
      function () {
        this.setState({
          editor: true,
          selectedIndex: item.id,
          editedOrder: null,
          editedValue: null
        })
      }.bind(this),
      100
    )
  }
  closeEditor = () => {
    this.setState({ editor: false, selectedIndex: null })
  }

  newComp = (type, e) => {
    this.setState({
      compType: type,
      preview: false,
      editComp: true
    })
    if (type === 'list') {
      this.viewSheets()
    }
    if (type === 'button') {
      this.viewScreens()
    }
    if (type === 'wordpress') {
      this.userData()
    }
    if (type === 'woocommerce') {
      this.userData()
    }
  }
  navigBtnFunc = () => {
    this.viewScreens()
    this.setState({
      navigBtn: true,
      urlBtn: null
    })
  }
  urlBtnFunc = () =>
    this.setState({
      urlBtn: true,
      navigBtn: null
    })
  btnTypeFunction = (type) => {
    this.setState({
      btnType: type
    })
  }
  chartTypeFunction = (type) => {
    this.setState({
      chartType: type,
      edit: true,
      wordpressURL: null,
      responsive: null
    })
  }
  enableWpFunc = () =>
    this.setState({
      edit: true
    })
  enableWooFunc = () =>
    this.setState({
      edit: true
    })
  textAlign = (e, { value }) => {
    this.setState({ align: value })
  }
  headerType1 = () => {
    this.setState({ h1: true, h2: null, h3: null })
  }
  headerType2 = () => {
    this.setState({ h1: null, h2: true, h3: null })
  }
  headerType3 = () => {
    this.setState({ h1: null, h2: null, h3: true })
  }
  screenBtnValueFunc = (e, { value, key }) => {
    this.setState({ screenBtnValue: value })
  }
  listValueFunc = (e, { value }) => {
    this.setState({ listValue: value, edit: true })
  }
  previewFunc = () => {
    this.setState({ fetching: true }, this.viewScreenComp)
  }
  manageCompFunc = () => {
    setTimeout(
      function () {
        this.setState({
          manageComp: !this.state.manageComp
        })
      }.bind(this),
      50
    )
  }
  clearAll = () => {
    this.setState({
      compValue: null,
      listValue: null,
      edit: null,
      screenBtnValue: null,
      urlBtnValue: null,
      navigBtn: null,
      urlBtn: null,
      lattitude: null,
      longitude: null,
      h1: null,
      h2: null,
      h3: null,
      align: null,
      btnType: null,
      responsive: null,
      success: null,
      responsive: true,
      imgURL: null,
      chartType: null,
      nestedSub: null
    })
  }

  viewScreens = (e) => {
    this.setState({ fetching: true })
    fetch('https://murkstomstag.herokuapp.com/api/v1/view/screens', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: this.state.userUnderscore
      })
    })
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        if (json.code === 200) {
          let raw = json.screens
          var screens = []
          for (let x in raw) {
            screens.push({
              value: raw[x].id,
              text: raw[x].name,
              key: raw[x].id
            })
          }
          this.setState({ fetching: false, screens: screens, empty: json.empty })
        } else {
          this.setState({ error: 'Internal Server Error |  code 500', loading: false })
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          error: error.message
        })
      })
  }

  viewSheets = (e) => {
    this.setState({ fetching: true })
    fetch('https://murkstomstag.herokuapp.com/api/v1/view/sheets', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: this.state.userUnderscore
      })
    })
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        let raw = json.sheets
        if (raw !== null) {
          var sheets = []
          for (let x in raw) {
            sheets.push({
              value: raw[x].value,
              text: raw[x].title,
              key: raw[x].title
            })
          }
        }
        this.setState({ fetching: false, sheets: sheets, empty: json.empty })
      })
      .catch((error) => {
        console.log(error)
        this.setState({ error: error.message, loading: false })
      })
  }

  submitComp = (id) => {
    let {
      compType,
      screenID,
      userUnderscore,
      compValue,
      latitude,
      longitude,
      urlBtnValue,
      screenBtnValue,
      urlBtn,
      navigBtn,
      listValue,
      screenBtnID,
      webviewHeight,
      wordpressURL,
      h1,
      h2,
      h3,
      align,
      btnType,
      imgURL,
      imgName,
      imgWidth,
      imgHeight,
      responsive,
      chartType,
      dataKey,
      dataKey2,
      nestedSub
    } = this.state
    this.setState({ fetching: true, error: null })
    if (compType !== 'wordpress') {
      this.setState({
        wordpressURL: null
      })
    }
    if (compType !== 'image') {
      this.setState({
        responsive: null
      })
    }
    fetch('https://murkstomstag.herokuapp.com/api/v1/new/comp', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: userUnderscore,
        screenID: screenID,
        data: {
          type: compType,
          value: compValue,
          latitude: latitude,
          longitude: longitude,
          urlBtn: urlBtn,
          urlBtnValue: urlBtnValue,
          screenBtnValue: screenBtnValue,
          navigBtn: navigBtn,
          listValue: listValue,
          screenBtnID: screenBtnID,
          webviewHeight: webviewHeight,
          wordpressURL: wordpressURL,
          h1: h1,
          h2: h2,
          h3: h3,
          align: align,
          btnType: btnType,
          imgURL: imgURL,
          imgName: imgName,
          width: parseInt(imgWidth, 10),
          height: parseInt(imgHeight, 10),
          responsive: responsive,
          chartType: chartType,
          dataKey: dataKey,
          dataKey2: dataKey2,
          nestedSub: nestedSub
        }
      })
    })
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        if (json.code === 200) {
          this.setState({ fetching: false })
          this.cancel()
          this.viewScreenComp()
        } else {
          this.setState({ error: 'Internal Server Error |  code 500', loading: false })
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          error: error.message
        })
      })
  }

  loadScrenFunc = (id) => {
    this.setState({ fetching: true, editor: false, manageComp: false })
    let { userUnderscore } = this.state
    fetch('https://murkstomstag.herokuapp.com/api/v1/screen/comp', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: userUnderscore,
        screenID: id
      })
    })
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        if (json.code === 200) {
          let raw = json.components.sort((a, b) =>
            a.order > b.order ? 1 : b.order > a.order ? -1 : 0
          )
          this.setState({
            comps: raw,
            screenName: json.screenName,
            fetching: false,
            out: true,
            screenID: id
          })
        } else {
          this.setState({ error: 'Internal Server Error |  code 500', fetching: false })
        }
      })
  }

  viewScreenComp = () => {
    this.setState({ fetching: true, editor: false, out: false })
    let { screenID, userUnderscore, preview, editComp } = this.state
    fetch('https://murkstomstag.herokuapp.com/api/v1/screen/comp', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: userUnderscore,
        screenID: screenID
      })
    })
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        if (json.code === 200) {
          let raw = json.components.sort((a, b) =>
            a.order > b.order ? 1 : b.order > a.order ? -1 : 0
          )
          for (let x in raw) {
            if (raw[x].type === 'chart') {
              var apiEndpoint = raw[x].value
              var nestedSub = raw[x].nestedSub
              this.chartAPI(apiEndpoint, nestedSub)
            }
            if (raw[x].type === 'rss') {
              var url = raw[x].value
              this.rssAPI(url)
            }
          }
          this.setState({
            manageComp: false,
            comps: raw,
            screenName: json.screenName,
            fetching: false,
            loading: false
          })
        } else {
          this.setState({ error: json.code, loading: false, fetching: false })
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          fetching: false,
          error: error.message
        })
      })
  }

  rssAPI = (url) => {
    this.setState({ rssLoading: true })
    fetch('https://api.rss2json.com/v1/api.json?rss_url=' + url)
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        console.log('json RSS:', json)
        this.setState({ rssLoading: false, rssFeed: json.items })
      })
      .catch((error) => {
        this.setState({
          rssLoading: false,
          error: error.message
        })
      })
  }

  chartAPI = (apiEndpoint, nestedSub) => {
    this.setState({ chartLoading: true, chartError: null })
    fetch(apiEndpoint)
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        console.log('json :', json)
        if (json.message !== undefined) {
          this.setState({ chartError: json.message })
        }
        if (json.error !== undefined) {
          this.setState({ chartError: json.status + ' ' + json.error })
        }
        if (nestedSub === undefined) {
          this.setState({ chartData: json })
        } else {
          this.setState({ chartData: json[nestedSub] })
        }
        this.setState({ chartLoading: false })
      })
      .catch((error) => {
        this.setState({
          chartLoading: false,
          chartError: error.message
        })
      })
  }
  deleteComp = (item) => {
    this.setState({ fetching: true, selectedIndex: item.id })
    let { screenID, userUnderscore } = this.state
    fetch('https://murkstomstag.herokuapp.com/api/v1/delete/maker/comp', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: userUnderscore,
        screenID: screenID,
        compID: item.id
      })
    })
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        if (json.code === 200) {
          this.setState({ fetching: false })
          this.viewScreenComp()
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          error: error.message
        })
      })
  }

  editComp = (item) => {
    this.setState({ fetching: true, selectedIndex: item.id })
    let { screenID, userUnderscore, editedValue, editedOrder } = this.state
    fetch('https://murkstomstag.herokuapp.com/api/v1/edit/maker/comp', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: userUnderscore,
        screenID: screenID,
        editedValue: editedValue,
        editedOrder: editedOrder,
        itemComp: item,
        compID: item.id
      })
    })
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        if (json.code === 200) {
          this.setState({ fetching: false })
          this.viewScreenComp()
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          error: error.message
        })
      })
  }

  userData = (e) => {
    this.setState({
      fetching: true
    })
    fetch('https://murkstomstag.herokuapp.com/api/v1/user/data', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: this.state.userUnderscore
      })
    })
      .then((response) => {
        return response.json()
      })
      .then((obj) => {
        if ((obj.code = 200)) {
          this.setState({
            fetching: false
          })
          if (obj !== null) {
            this.setState({
              wordpressURL: obj.wordpressURL,
              storeurl: obj.storeurl,
              accent: obj.accent,
              accent2: obj.accent2,
              bgcolor: obj.bgcolor
            })
          }
        } else {
          this.setState({
            fetching: false,
            error: 'Internal Server Error |  code 500'
          })
        }
      })
      .catch((error) => {
        console.log(error)
        this.setState({ error: error.message, loading: false })
      })
  }

  singleRow = () => {
    this.setState({
      done: false,
      singleRow: true
    })
  }

  goBack = (e) => {
    this.setState({ done: true, singleRow: false, selectedIndex: null })
  }

  render () {
    let {
      error,
      screenName,
      editComp,
      fetching,
      manageComp,
      editor,
      selectedIndex,
      userUnderscore,
      singleRow,
      out,
      accent2,
      accent,
      bgcolor,
      confirm,
      loading,
      drawer,
      chartData,
      rssLoading,
      chartLoading,
      chartError
    } = this.state

    const rssItems = this.state.rssFeed.map((item, index) => (
      <div className='maker-card mbs lightshadow' key={index}>
        <h3>{entities.decode(item.title)}</h3>
        <div className='mbs'>{renderHTML(item.description)}</div>
        <Button size='mini' color='black' basic target='_blank' href={item.link}>
          Read Article
        </Button>
      </div>
    ))
    const screenDetails = this.state.comps.map((item, index) => (
      <div
        className='mbs'
        style={{
          borderColor: manageComp ? '#444' : 'transparent',
          border: manageComp ? '4px solid' : '0px',
          marginLeft: manageComp ? '14px' : '0px',
          marginRight: manageComp ? '14px' : '0px',
          backgroundColor: manageComp ? '#fcfcfc' : 'transparent'
        }}
        key={index}>
        <Transition visible={manageComp} animation='fly right' duration={200}>
          <Button.Group style={{ marginBottom: manageComp ? '14px' : '0px' }}>
            {!editor && !out && (
              <Button
                animated='vertical'
                floated='left'
                style={{ backgroundColor: 'transparent', color: '#000' }}
                size='tiny'
                compact
                onClick={() => this.launchEditor(item)}>
                <Button.Content visible>Edit</Button.Content>
                <Button.Content hidden>
                  <Icon name='pencil' />
                </Button.Content>
              </Button>
            )}

            {!out && (
              <Button
                floated='right'
                size='tiny'
                style={{ backgroundColor: 'transparent', color: 'red' }}
                compact
                onClick={() => this.deleteComp(item)}>
                <Icon name='trash' />
                {selectedIndex === item.id && 'Delete'}
              </Button>
            )}
          </Button.Group>
        </Transition>

        {item.type === 'text' && !singleRow && (
          <div className='maker-lucid  wraptext' style={{ textAlign: item.align }}>
            <p>{item.value}</p>
          </div>
        )}
        {item.type === 'rss' && !singleRow && (
          <div>
            {!rssLoading ? (
              rssItems
            ) : (
              <Loader active inline='centered' size='small'>
                Downloading RSS Feed...
              </Loader>
            )}
          </div>
        )}
        {item.type === 'header' && !singleRow && (
          <div className='maker-lucid' style={{ textAlign: item.align }}>
            {item.h1 && <h1>{item.value}</h1>}
            {item.h2 && <h2>{item.value}</h2>}
            {item.h3 && <h3>{item.value}</h3>}
            {/* </Container> */}
          </div>
        )}
        {item.type === 'button' && !singleRow && (
          <div>
            {item.urlBtn && (
              <div className='maker-lucid lightshadow'>
                <Button
                  // basic={item.btnType === 'outline'}
                  rel='noopener noreferrer'
                  href={item.urlBtnValue}
                  target='_blank'
                  style={{
                    backgroundColor: item.btnType === 'filled' ? accent : '#fff',
                    borderColor: item.btnType === 'filled' ? 'transparent' : accent2,
                    color: item.btnType === 'filled' ? '#fff' : '#555',
                    borderStyle: 'solid',
                    borderWidth: '2px'
                  }}
                  fluid>
                  {item.value}
                </Button>
              </div>
            )}
            {item.navigBtn && (
              <div className='maker-lucid lightshadow'>
                <Button
                  fluid
                  style={{
                    backgroundColor: item.btnType === 'filled' ? accent : '#fff',
                    borderColor: item.btnType === 'filled' ? 'transparent' : accent2,
                    color: item.btnType === 'filled' ? '#fff' : '#555',
                    borderStyle: 'solid',
                    borderWidth: '2px'
                  }}
                  target='_blank'
                  loading={fetching}
                  rel='noopener noreferrer'
                  onClick={() => this.loadScrenFunc(item.screenBtnValue)}>
                  {item.value}
                </Button>
              </div>
            )}
          </div>
        )}
        {item.type === 'map' && !singleRow && (
          <div className='maker-lucid'>
            <Image fluid src={phmap} />
            <p className='center'>
              Placeholder <Icon name='exclamation triangle' style={{ color: '#F4D271' }} />
            </p>
          </div>
        )}
        {item.type === 'webview' && !singleRow && (
          <div className='maker-lucid' style={{ height: item.webviewHeight + '%' }}>
            <iframe title='webview' src={item.value} style={{ width: '100%', height: '100%' }} />
          </div>
        )}
        {item.type === 'image' && !singleRow && (
          <div className='maker-lucid'>
            {item.responsive ? (
              <div>
                {item.imgURL ? (
                  <Image rounded src={item.imgURL} fluid />
                ) : (
                  <Image rounded src={item.value} fluid />
                )}
              </div>
            ) : (
              <div
                style={{
                  alignItems: item.align === 'center' ? 'center' : null,
                  display: 'flex'
                }}>
                {item.imgURL ? (
                  <Image
                    rounded
                    src={item.imgURL}
                    centered={item.align === 'center'}
                    style={{
                      width: item.width + 'px',
                      height: item.height + 'px',
                      alignSelf: item.align === 'right' ? 'flex-end' : null
                    }}
                  />
                ) : (
                  <Image
                    rounded
                    src={item.value}
                    centered={item.align === 'center'}
                    style={{
                      width: item.width + 'px',
                      height: item.height + 'px',
                      alignSelf: item.align === 'right' ? 'flex-end' : null
                    }}
                  />
                )}
              </div>
            )}
          </div>
        )}
        {item.type === 'list' && (
          <div>
            <StaticSheet
              sheetID={item.listValue}
              userUnderscore={userUnderscore}
              singleRow={this.singleRow}
              goBack={this.goBack}
            />
          </div>
        )}

        {item.type === 'video' && !singleRow && (
          <div className='maker-lucid lightshadow'>
            <ReactPlayer url={item.value} width='100%' height='100%' />
          </div>
        )}
        {item.type === 'audio' && !singleRow && (
          <div className='maker-lucid lightshadow'>
            <ReactPlayer controls url={item.value} width='100%' height='50px' />
          </div>
        )}
        {item.type === 'phone' && !singleRow && (
          <div className='maker-card lightshadow'>
            <Label style={{ backgroundColor: '#f1f2f3' }}>
              <Icon name='phone' color='black' />
              Phone
            </Label>
            <div className='mts'>
              <Mailto tel={item.value} />
            </div>
          </div>
        )}
        {item.type === 'email' && !singleRow && (
          <div className='maker-card lightshadow'>
            <Label style={{ backgroundColor: '#f1f2f3' }}>
              <Icon name='mail' color='black' />
              Email
            </Label>
            <div className='mts'>
              <Mailto email={item.value} />
            </div>
          </div>
        )}
        {item.type === 'address' && !singleRow && (
          <div className='maker-card lightshadow'>
            <Label style={{ backgroundColor: '#f1f2f3' }}>
              <Icon name='home' color='black' />
              Address
            </Label>
            <div className='mts'>
              <h4>{item.value}</h4>
            </div>
          </div>
        )}

        {item.type === 'admob' && !singleRow && (
          <div className='maker-lucid lightshadow'>
            <Image fluid src={admobHolder} />
          </div>
        )}
        {item.type === 'wordpress' && !singleRow && (
          <div className='maker-card lightshadow center'>
            <p>
              <Icon name='exclamation triangle' color='yellow' />
              Under maintenance.
            </p>
            <h4>
              Please visit this <a href='/wordpress'>page</a> to preview your blog.
            </h4>
          </div>
        )}

        {item.type === 'woocommerce' && !singleRow && (
          <div className='maker-card lightshadow center'>
            <p>
              <Icon name='exclamation triangle' color='yellow' />
              Under maintenance.
            </p>
          </div>
        )}

        {item.type === 'chart' && !singleRow && (
          <div>
            {chartLoading && (
              <Loader size='small' inline='centered' active>
                Rendering graph...
              </Loader>
            )}
            {chartError && (
              <div className='maker-card'>
                <Message>
                  <h3>Error</h3>
                  {chartError}
                </Message>
              </div>
            )}
            {item.chartType === 'line' && !chartError && (
              <center className='maker-card lightshadow centerX'>
                <LineChart width={220} height={100} data={chartData}>
                  <Line
                    dot={false}
                    type='monotone'
                    dataKey={item.dataKey}
                    stroke={accent}
                    strokeWidth={2}
                  />
                  <Legend />
                </LineChart>
              </center>
            )}

            {item.chartType === 'bars' && !chartError && (
              <center className='maker-card lightshadow centerX'>
                <BarChart width={200} height={200} data={chartData}>
                  <CartesianGrid strokeDasharray='3 3' />
                  <YAxis width={20} dataKey={item.dataKey} />
                  <Bar barSize={2} dataKey={item.dataKey} fill={accent} />
                  <Legend />
                </BarChart>
              </center>
            )}

            {item.chartType === 'area' && !chartError && (
              <center className='maker-card lightshadow centerX'>
                <AreaChart width={190} height={200} data={chartData}>
                  <YAxis width={35} dataKey={item.dataKey} />
                  <XAxis dataKey={item.dataKey2} />
                  <Area
                    type='linear'
                    dataKey={item.dataKey}
                    strokeWidth={0}
                    fill='#000'
                    fillOpacity={1}
                  />
                </AreaChart>
              </center>
            )}
          </div>
        )}
        {manageComp && <Divider hidden />}
        {selectedIndex === item.id && (
          <div className='dropshadow mts'>
            {editor && manageComp && (
              <div style={{ backgroundColor: '#fff', padding: '15px' }}>
                <Form>
                  <Label color='black' size='tiny' label='Type' content={'type: ' + item.type} />
                  <div className='mtbs'>
                    <div className='mbs'>
                      <Input
                        type='text'
                        label='Value'
                        fluid
                        disabled={item.type === 'map' || item.type === 'list'}
                        placeholder={item.value}
                        onChange={this.handleChange}
                        name='editedValue'
                      />
                    </div>
                    <Input
                      type='number'
                      label='Order'
                      fluid
                      placeholder={item.order}
                      onChange={this.handleChange}
                      name='editedOrder'
                    />
                  </div>
                  <div className='lightshadow mbs'>
                    <Button
                      animated='fade'
                      size='tiny'
                      style={{ backgroundColor: '#F4D271', color: '#000' }}
                      fluid
                      onClick={() => this.editComp(item)}>
                      <Button.Content visible>Save Changes</Button.Content>
                      <Button.Content hidden>
                        <Icon name='save' />
                      </Button.Content>
                    </Button>
                  </div>
                </Form>
                <Button
                  animated='fade'
                  color='black'
                  basic
                  fluid
                  size='tiny'
                  onClick={() => this.closeEditor(item)}>
                  <Button.Content visible>Cancel</Button.Content>
                  <Button.Content hidden>
                    <Icon name='close' />
                  </Button.Content>
                </Button>
              </div>
            )}
          </div>
        )}
      </div>
    ))

    return (
      <div className='masterdiv'>
        <Grid stackable verticalAlign='middle' fluid centered reversed='mobile'>
          <Grid.Column width='1' />
          <Grid.Column width='8' style={{ backgroundColor: '#fff' }}>
            {!error && (
              <div className='screen-card'>
                <ScrollArea trackHidden height='600px'>
                  <div className='mbs center'>
                    <h2>{screenName || '...'}</h2>
                  </div>
                  <MakerNavig
                    {...this.state}
                    previewFunc={this.previewFunc.bind(this)}
                    manageCompFunc={this.manageCompFunc.bind(this)}
                  />

                  {!editComp && !out && (
                    <div>
                      <MakerComp newComp={this.newComp.bind(this)} />
                    </div>
                  )}
                  {editComp && (
                    <MakerInputs
                      {...this.state}
                      handleChange={this.handleChange.bind(this)}
                      headerType1={this.headerType1.bind(this)}
                      headerType2={this.headerType2.bind(this)}
                      headerType3={this.headerType3.bind(this)}
                      urlBtnFunc={this.urlBtnFunc.bind(this)}
                      navigBtnFunc={this.navigBtnFunc.bind(this)}
                      screenBtnValueFunc={this.screenBtnValueFunc.bind(this)}
                      listValueFunc={this.listValueFunc.bind(this)}
                      submitComp={this.submitComp.bind(this)}
                      cancel={this.cancel.bind(this)}
                      enableWooFunc={this.enableWooFunc.bind(this)}
                      enableWpFunc={this.enableWpFunc.bind(this)}
                      textAlign={this.textAlign.bind(this)}
                      btnTypeFunction={this.btnTypeFunction.bind(this)}
                      handleUpload={this.handleUpload.bind(this)}
                      responsiveImg={this.responsiveImg.bind(this)}
                      cancelResponsive={this.cancelResponsive.bind(this)}
                      chartTypeFunction={this.chartTypeFunction.bind(this)}
                    />
                  )}
                </ScrollArea>
              </div>
            )}
          </Grid.Column>
          <Grid.Column width='7' className='mtb'>
            <div className='newframe'>
              <div className='newframe-content' style={{ backgroundColor: bgcolor }}>
                <div className='containerX' />
                <div className='newframe-content-body'>
                  <div>
                    {error && (
                      <div className='mt'>
                        <Error {...this.state} />
                      </div>
                    )}
                    {!singleRow && !fetching && !loading && drawer && (
                      <div style={{ width: '100%' }}>
                        <div
                          style={{ position: 'fixed', zIndex: 999999, top: '14px', left: '14px' }}
                          className='cursor'>
                          <Icon name='bars' size='large' />
                        </div>
                        <div style={{ height: '35px' }} />
                      </div>
                    )}
                    <ScrollArea trackHidden height='580px'>
                      {fetching && (
                        <div className='mtb'>
                          <Loader size='small' inline='centered' active />
                        </div>
                      )}
                      {!fetching && <div>{screenDetails}</div>}
                    </ScrollArea>
                  </div>
                </div>
              </div>
            </div>
          </Grid.Column>
        </Grid>
        <center className='mt'>
          {!confirm ? (
            <Button color='black' basic onClick={() => this.confirm()}>
              Delete screen
            </Button>
          ) : (
            <Button
              disabled={loading}
              loading={loading}
              color='black'
              onClick={() => this.deleteScreen()}>
              Are you sure?
            </Button>
          )}
          <ExperimentalPreview />
        </center>
      </div>
    )
  }
}
